"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
var _utils = require("../utils");
var _icon = _interopRequireDefault(require("../icon"));
var _use = (0, _utils.use)('notice-bar'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  props: {
    text: String,
    mode: String,
    // closeable | link | expanded
    theme: String,
    color: String,
    textAlign: String,
    leftTag: String,
    leftIcon: String,
    leftIconZziconfont: Boolean,
    leftIconClassPrefix: String,
    rightText: String,
    rightIcon: {
      type: [String, Boolean],
      default: ''
    },
    wrapable: Boolean,
    // 是否开启换行
    background: String,
    delay: {
      type: [String, Number],
      default: 1
    },
    swipe: {
      type: Boolean,
      default: false
    },
    swipeInterval: {
      type: [String, Number],
      default: 16
    },
    // 是否开启滚动
    scrollable: {
      type: Boolean,
      default: true
    },
    speed: {
      type: [String, Number],
      default: 100
    },
    showGradient: Boolean,
    radius: Boolean
  },
  data: function data() {
    return {
      wrapWidth: 0,
      firstRound: true,
      duration: 0,
      offsetWidth: 0,
      showNoticeBar: true,
      animationClass: ''
    };
  },
  watch: {
    text: {
      handler: function handler() {
        var _this = this;
        this.$nextTick(function () {
          var _this$$refs = _this.$refs,
            wrap = _this$$refs.wrap,
            content = _this$$refs.content;
          if (!wrap || !content) {
            return;
          }
          var wrapWidth = wrap.getBoundingClientRect().width;
          var offsetWidth = content.getBoundingClientRect().width;
          if (_this.scrollable && offsetWidth > wrapWidth) {
            _this.wrapWidth = wrapWidth;
            _this.offsetWidth = offsetWidth;
            _this.duration = offsetWidth / +_this.speed;
            _this.animationClass = bem('play');
          }
        });
      },
      immediate: true
    }
  },
  methods: {
    onClick: function onClick() {
      var _this2 = this;
      this.$emit('close', function () {
        _this2.showNoticeBar = false;
      });
    },
    onClickIcon: function onClickIcon(e) {
      // 修复点击icon触发两次close事件问题
      e.stopPropagation();
      if (this.mode === 'closeable') {
        this.showNoticeBar = false;
        this.$emit('close');
      }
      if (this.mode === 'link') {
        this.$emit('link');
      }
      if (this.mode === 'expanded') {
        this.$emit('expanded');
        this.wrapable = !this.wrapable;
        this.scrollable = !this.scrollable;
      }
    },
    onClickText: function onClickText(e) {
      e.stopPropagation();
      this.$emit('clickText');
    },
    onAnimationEnd: function onAnimationEnd() {
      var _this3 = this;
      this.firstRound = false;
      this.$nextTick(function () {
        _this3.duration = (_this3.offsetWidth + _this3.wrapWidth) / +_this3.speed;
        _this3.animationClass = bem('play--infinite');
      });
    }
  },
  mounted: function mounted() {
    // wrapable 开启换行
    // scrollable 开启滚动
    if (this.mode === 'expanded' && this.wrapable) {
      this.scrollable = false;
    }
    if (this.swipe) {
      var _this$$refs2 = this.$refs,
        swipeContainer = _this$$refs2.swipeContainer,
        swipeContent = _this$$refs2.swipeContent,
        swipeCopyContent = _this$$refs2.swipeCopyContent;
      var count = 0;
      var loop = function loop() {
        // console.log(swipeCopyContent.offsetWidth, swipeContainer.scrollLeft)
        if (swipeCopyContent.offsetWidth <= swipeContainer.scrollLeft) {
          var t = count / 2 ? swipeContent : swipeCopyContent;
          swipeContainer.appendChild(t);
          swipeContainer.scrollLeft -= swipeCopyContent.offsetWidth;
          count++;
        } else {
          swipeContainer.scrollLeft += 1;
        }
      };
      this.timer = setInterval(loop, +this.swipeInterval);
    }
  },
  destroyed: function destroyed() {
    this.timer && clearInterval(this.timer);
  },
  render: function render(h) {
    var _bem;
    var mode = this.mode,
      theme = this.theme,
      rightIcon = this.rightIcon,
      showGradient = this.showGradient,
      radius = this.radius;
    // 有配 iconName ，则不滚动， scrollable 为 false
    var iconName = '';
    if (mode === 'link' || mode === 'expanded') {
      if (rightIcon !== false && typeof rightIcon === 'string') {
        iconName = rightIcon || 'arrow-right';
      }
    }
    var _showGradient = showGradient || this.scrollable && !this.wrapable && !iconName || mode === 'expanded' && !this.wrapable;

    // console.log('iconName', iconName, mode)
    var barStyle = {
      color: this.color,
      background: this.background
    };
    var contentStyle = {
      textAlign: this.textAlign,
      paddingLeft: this.firstRound ? 0 : this.wrapWidth + 'px',
      animationDelay: (this.firstRound ? this.delay : 0) + 's',
      animationDuration: this.duration + 's'
    };
    return h("div", {
      "directives": [{
        name: "show",
        value: this.showNoticeBar
      }],
      "class": bem((_bem = {
        scrollable: this.scrollable && !iconName,
        wrapable: this.wrapable
      }, _bem[theme] = theme, _bem.expanded = mode === 'expanded', _bem.radius = radius, _bem)),
      "style": barStyle,
      "on": {
        "click": this.onClick
      }
    }, [this.leftTag && h("div", {
      "class": bem('left-tag')
    }, [this.leftTag]), this.leftIcon && h(_icon.default, {
      "class": bem('left-icon'),
      "attrs": {
        "name": this.leftIcon,
        "classPrefix": this.leftIconClassPrefix || (this.leftIconZziconfont ? 'zziconfont' : undefined)
      },
      "on": {
        "click": this.onClickIcon
      }
    }), this.swipe ? h("div", {
      "ref": "swipeContainer",
      "class": [bem('wrap'), this.mode ? bem(this.mode) : undefined],
      "style": "white-space: nowrap;"
    }, [h("span", {
      "ref": "swipeContent"
    }, [this.slots() || this.text]), h("span", {
      "ref": "swipeCopyContent"
    }, [this.slots() || this.text])]) : h("div", {
      "ref": "wrap",
      "class": [bem('wrap'), this.mode ? bem(this.mode) : undefined]
    }, [h("div", {
      "ref": "content",
      "class": [bem('content'), this.animationClass, {
        'z-ellipsis': !this.scrollable && !this.wrapable
      }],
      "style": contentStyle,
      "on": {
        "animationend": this.onAnimationEnd,
        "webkitAnimationEnd": this.onAnimationEnd
      }
    }, [this.slots() || this.text])]), iconName && this.rightText && h("span", {
      "class": bem('right-text'),
      "on": {
        "click": this.onClickText
      }
    }, [this.rightText]), iconName && h(_icon.default, {
      "class": bem('right-icon'),
      "attrs": {
        "name": iconName,
        "classPrefix": "zziconfont"
      },
      "on": {
        "click": this.onClickIcon
      }
    }), _showGradient && h("div", {
      "class": bem('scrollable-gradient')
    })]);
  }
});
exports.default = _default;